import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageShell } from '../../shared/components/page-shell/page-shell';
import { ExecutablesTab } from './components/executables-tab/executables-tab';
import { ImagingTab } from './components/imaging-tab/imaging-tab';
import { TranslateModule } from '@ngx-translate/core';
import { AppTabs } from '../../shared/components/app-tabs/app-tabs';

import { ProfileTab } from './components/profile-tab/profile-tab';
// import { SecurityTab } from './components/security-tab/security-tab';

import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, TranslateModule, PageShell, ExecutablesTab, ImagingTab, AppTabs, ProfileTab],
  templateUrl: './settings.html',
})
export class Settings implements OnInit {
  /** A signal, so a later ?tab= (the subscription below) redraws the zoneless page. */
  readonly activeTab = signal('profile');

  constructor(private route: ActivatedRoute) {}

  /**
   * The clinic's own settings (subscription, clinic, billing, registration
   * fields, Novigest, agenda, access profiles, users, diagnostics, specialities,
   * online booking, audit logs) live in the CRM admin, under the clinic's
   * Settings, since 2026-11-03.
   *
   * A lapsed plan no longer needs handling here: planGuard sends everyone,
   * owners included, to /plan-expired.
   */
  readonly tabs = [
    { value: 'profile', label: 'settings_tab_profile' },
    { value: 'executables', label: 'settings_tab_executables' },
    { value: 'imaging', label: 'settings_tab_imaging' },
    // { value: 'security', label: 'settings_tab_security' },
  ];

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.activeTab.set(this.tabFor(params['tab'] || this.activeTab()));
    });
  }

  setActiveTab(tabId: string) {
    this.activeTab.set(this.tabFor(tabId));
  }

  /** A link or bookmark to a tab that moved to the admin (?tab=users) opens Profile. */
  private tabFor(tabId: string): string {
    return this.tabs.some((t) => t.value === tabId) ? tabId : 'profile';
  }
}
